import {createUseStyles} from "react-jss";
import React from "react";

type Props = {
    headline: string
    count: number
    subLine: string
}

const UserCounter = (
    {
        headline,
        count,
        subLine
    }: Props
) => {
    const styles = useStyles();
    return (
        <div className={styles.root}>
            <span className={styles.headline}>{headline}</span>
            <span className={styles.count}>{count}</span>
            <span className={styles.subLine}>{subLine}</span>
        </div>
    )
}

export default UserCounter;

const useStyles = createUseStyles({
    root: {
        textAlign: "center",
    },
    headline: {

    },
    count:{
        fontSize: "3rem",
        display: "block",
        lineHeight: "1.5em",
    },
    subLine: {

    }
});
